import _ from 'lodash';
import { convertMarkdownToHtml, displayDate } from "~/plugins/functions/display";

export interface IModelConversationDetailMessageResponse {
  aiMessage: string | null;
  conversationId: string;
  createdAt: string | Date;
  humanMessage: string
  id: string
  status: string
  updatedAt: string | Date;
  files: IModelPOSTConversationAssociationConversationFileRespone[];
  isMaxToken: boolean;
  parentId: string | null;
  versionPosition: number;
  versionTotal: number;
  processHeader: string;
  sources: IModelConversationSource[];
  genImage: any;
  generatedImages: IModelPOSTConversationAssociationConversationFileRespone[];
}


export class ModelConversationDetailProcess {
  title: string;
  description: string;
  createdAt: string | Date;
  constructor(props = {} as any) {
    this.title = '';
    this.description = '';
    this.createdAt = '';
  }
}

export class ModelConversationDetailMessage {
  aiMessage: string | null;
  conversationId: string;
  createdAt: string | Date;
  humanMessage: string
  id: string
  status: string
  updatedAt: string | Date;
  userAvatar: string;
  filesList: ModelPOSTConversationAssociationConversationFile[];
  isMaxToken: boolean;
  parentId: string | null;
  versionPosition: number;
  versionTotal: number;

  displayCreatedAt: string;
  displayUpdatedAt: string;
  isNewAIMessage: boolean;
  aiMessageList: string[];
  processHeader: string;
  processPreviousTitle: string;
  processList: ModelConversationDetailProcess[];
  isEndStream: boolean;

  sourceList: ModelSource[];
  isGenerateImage: boolean;
  generatedImagesList: ModelPOSTConversationAssociationConversationFile[];


  constructor(props = {} as IModelConversationDetailMessageResponse) {
    this.aiMessage = convertMarkdownToHtml(props.aiMessage || '', { isEndStream: true })
    this.conversationId = props.conversationId
    this.createdAt = props.createdAt
    this.humanMessage = props.humanMessage
    this.id = props.id
    this.status = props.status
    this.updatedAt = props.updatedAt;
    this.filesList = (props.files || []).map(e => new ModelPOSTConversationAssociationConversationFile(e));
    this.isMaxToken = props.isMaxToken || false;
    this.parentId = props.parentId;
    this.versionPosition = props.versionPosition || 1;
    this.versionTotal = props.versionTotal || 1;

    this.displayCreatedAt = displayDate(this.createdAt, {
      isOnlyTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isOnlyTime: true
    });
    this.userAvatar = '/images/contents/content-user-1.png';

    this.isNewAIMessage = false;
    this.aiMessageList = []
    this.processHeader = props.processHeader || ` `;
    this.processPreviousTitle = '';
    this.processList = [];
    this.isEndStream = false;
    this.sourceList = (props.sources || []).map(e => new ModelSource(e));
    this.isGenerateImage = false;
    this.generatedImagesList = (props.genImage || []).map((e:any) => new ModelPOSTConversationAssociationConversationFile(e));
  }
}

export interface IModelConversationDetailResponse {
  id: string;
  conversationMessages: IModelConversationDetailMessageResponse[];
  presetId: number;
  userId: number;
  name: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  preset: IModelPOSTConversationDetailPresetResponse[];
  isArchived: boolean;
  createdBy: string;
  updatedBy: string;
}

export class ModelConversationDetail {
  id: string;
  conversationMessageList: ModelConversationDetailMessage[];
  presetId: number;
  userId: number;
  name: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  presetList: ModelPOSTConversationDetailPreset[];
  isArchived: boolean;
  createdBy: string;
  updatedBy: string;

  displayCreatedAt: string;
  displayUpdatedAt: string;
  natSubscribeValue: any;
  totalConversationMessageList: ModelConversationDetailMessage[];

  constructor(props = {} as IModelConversationDetailResponse) {
    this.id = props.id || '-';
    this.conversationMessageList = (props.conversationMessages || []).map(e => new ModelConversationDetailMessage(e));
    this.presetId = props.presetId || 0;
    this.userId = props.userId || 0;
    this.name = props.name || '';
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    // this.preset = new ModelPOSTConversationDetailPreset(props.preset);
    this.presetList = (props.preset || []).map(e => new ModelPOSTConversationDetailPreset(e));
    this.isArchived = props.isArchived || false;
    this.createdBy = props.createdBy || '';
    this.updatedBy = props.updatedBy || '';

    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true
    });
    this.natSubscribeValue = null;
    this.totalConversationMessageList = _.cloneDeep(this.conversationMessageList);
  }
}

export interface IModelPOSTConversationDetailResponse {
  id: string;
  presetId: number;
  userId: number;
  name: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  preset: IModelPOSTConversationDetailPresetResponse;
}

export interface IModelPOSTConversationDetailPresetResponse {
  id: number;
  name: string;
  modelName: string;
  tools: string[];
  knowledgeBase: string[];
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelPOSTConversationDetailPreset {
  id: number;
  name: string;
  modelName: string;
  toolsList: string[];
  knowledgeBaseList: string[];
  createdAt: string | Date;
  updatedAt: string | Date;

  constructor(props = {} as IModelPOSTConversationDetailPresetResponse) {
    props = props ?? {} as IModelPOSTConversationDetailPresetResponse;
    this.id = props.id || 0;
    this.name = props.name || '';
    this.modelName = props.modelName || '';
    this.toolsList = props.tools || [];
    this.knowledgeBaseList = props.knowledgeBase || [];
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
  }
}


export interface IModelPOSTConversationAssociationConversationFileRespone {
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;
}

export class ModelPOSTConversationAssociationConversationFile {
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;

  displayFile: string;

  constructor(props = {} as IModelPOSTConversationAssociationConversationFileRespone) {
    this.fileName = props.fileName || '';
    this.filePath = props.filePath || '';
    this.fileSize = props.fileSize || '';
    this.mimeType = props.mimeType || '';

    this.displayFile = ''
  }
}

export interface IModelConversationSource {
  url: string;
  type: string;
  title: string;
}

export class ModelSource {
  url: string;
  type: string;
  title: string;

  constructor(props = {} as IModelConversationSource) {
    this.url = props.url || '';
    this.type = props.type || '';
    this.title = props.title || '';
  }
}